/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TileDto } from './tileDto';

export interface TileGeometryDto { 
    tile?: TileDto;
    position?: TileGeometryDto.PositionEnum;
    x?: number;
    y?: number;
    visible?: boolean;
}
export namespace TileGeometryDto {
    export type PositionEnum = 'Up' | 'Right' | 'Down' | 'Left';
    export const PositionEnum = {
        Up: 'Up' as PositionEnum,
        Right: 'Right' as PositionEnum,
        Down: 'Down' as PositionEnum,
        Left: 'Left' as PositionEnum
    };
}